import React, { useEffect, useState } from "react";
import Sortist from "../../components/sortList/sortList";
import TabListShimmer from "./TabListShimmer";

interface TabItem {
  id: string[];
  name: string;
  count: number;
}

interface TabListProps {
  body: any;
  tabClick: string;
  handleTabClick: (tabName: string) => void;
  handleSearchTabClick: (item: TabItem | null) => void;
  searchQuery: any,
  tabData: any
}

const TabList: React.FC<TabListProps> = ({
  body,
  tabClick,
  handleTabClick,
  handleSearchTabClick,
  searchQuery,
  tabData
}) => {
  // const [tabData, setTabData] = useState<{
  //   data: { tabList: TabItem[] };
  // } | null>(null);
  const [Tablist, setTablist] = useState<any>({});
  const [moreTablist, setMoretablist] = useState<any>({});

  useEffect(() => {
    if (tabData?.data?.tabList?.length) {
      if (tabData?.data?.tabList?.length > 4) {
        let firstFiveTabData = tabData?.data?.tabList?.slice(0, 4);
        let lastFiveTabData = tabData?.data?.tabList?.slice(4, tabData?.data?.tabList?.length);
        if(tabClick?.length){
          let index = lastFiveTabData.findIndex((tab:any)=> tab.name == tabClick);
          if(index > -1){
          let oldTabData = firstFiveTabData[3];
          let moreNewTabData = lastFiveTabData[index];
          let previousTabList = firstFiveTabData;
          let previousMoreTabList = lastFiveTabData;
          previousTabList[3] = moreNewTabData;
          previousMoreTabList[index] = oldTabData;
          setTablist(previousTabList);
          setMoretablist(previousMoreTabList);  
          }else{
            setTablist(firstFiveTabData);
            setMoretablist(lastFiveTabData);
          }
        }else{
        setTablist(firstFiveTabData);
        setMoretablist(lastFiveTabData);
        }
      } else {
        setTablist(tabData?.data?.tabList);
        setMoretablist([]);
      }
      
    } else {
      setTablist([]);
      setMoretablist([]);
    }
  }, [tabData, tabClick]);

  const handleMoreTabClick = (moreItem: TabItem, index: number) => {
    // swap the more tab item with last tab item
    let oldTabData = Tablist[3];
    let moreNewTabData = moreTablist[index];
    let previousTabList = Tablist;
    let previousMoreTabList = moreTablist;
    previousTabList[3] = moreNewTabData;
    previousMoreTabList[index] = oldTabData;
    handleTabClick(moreItem.name);
    handleSearchTabClick(moreItem);
    setTablist(previousTabList);
    setMoretablist(previousMoreTabList);
  };

  return (
    <>
      {
        Tablist?.length ?
          <>
          {/* desktop */}
          <span className="flex m-none mx-dev-1">
            <li
              onClick={() => {
                handleTabClick("Search");
                handleSearchTabClick('null');
              }}
            >
              {" "}
              <a
                className={`pr-tab-links cursor-pointer ${tabClick === "Search" ? "active" : ""
                  }`}
              >
                {" "}
                Search{" "}
              </a>{" "}
            </li>
            {
              Tablist.map((item: TabItem) => {
                return (
                  <li
                    key={item.name}
                    onClick={() => {
                      handleTabClick(item.name);
                      handleSearchTabClick(item);
                    }}
                  >
                    {" "}
                    <a
                      className={`pr-tab-links cursor-pointer ${tabClick === item.name ? "active" : ""
                        }`}
                    >
                      {" "}
                      {item.name}
                    </a>{" "}
                  </li>
                );
              })}
            {
              moreTablist?.length ?
                <li className="dropdowns">
                  {" "}
                  <a className="pr-tab-links cursor-pointer">
                    {" "}
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 19C10 20.1 10.9 21 12 21C13.1 21 14 20.1 14 19C14 17.9 13.1 17 12 17C10.9 17 10 17.9 10 19Z"
                        fill="#969BAC"
                      />
                      <path
                        d="M10 4.99997C10 6.09997 10.9 6.99997 12 6.99997C13.1 6.99997 14 6.09997 14 4.99997C14 3.89997 13.1 2.99997 12 2.99997C10.9 2.99997 10 3.89997 10 4.99997Z"
                        fill="#969BAC"
                      />
                      <path
                        d="M10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 9.99997 12 9.99997C10.9 9.99997 10 10.9 10 12Z"
                        fill="#969BAC"
                      />
                    </svg>{" "}
                    More
                  </a>
                  <ul className="dropdown-contents">
                    {
                      moreTablist.map((moreItem: TabItem, index: number) => {
                        return (
                          <li
                            key={moreItem.name}
                            onClick={() => {
                              handleMoreTabClick(moreItem, index);
                            }}>
                            {" "}
                            <a className="a-link cursor-pointer">
                              {" "}
                              {moreItem.name}{" "}
                            </a>{" "}
                          </li>
                        )
                      }
                      )
                    }
                  </ul>
                </li>
                : ''
            }
            </span>
            {/* Mobile */}
            <span className="flex l-flex-none">
            <li
              onClick={() => {
                handleTabClick("Search");
                handleSearchTabClick('null');
              }}
            >
              {" "}
              <a
                className={`pr-tab-links cursor-pointer ${tabClick === "Search" ? "active" : ""
                  }`}
              >
                {" "}
                Search{" "}
              </a>{" "}
            </li>
            {
              Tablist.map((item: TabItem) => {
                return (
                  <li
                    key={item.name}
                    onClick={() => {
                      handleTabClick(item.name);
                      handleSearchTabClick(item);
                    }}
                  >
                    {" "}
                    <a
                      className={`pr-tab-links cursor-pointer ${tabClick === item.name ? "active" : ""
                        }`}
                    >
                      {" "}
                      {item.name}
                    </a>{" "}
                  </li>
                );
              })}
            {
              moreTablist?.length ?
                <> 
                  {
                      moreTablist.map((moreItem: TabItem, index: number) => {
                        return (
                          <li
                            key={moreItem.name}
                            onClick={() => {
                              handleMoreTabClick(moreItem, index);
                            }}>
                            {" "}
                            <a className="pr-tab-links cursor-pointer">
                              {" "}
                              {moreItem.name}{" "}
                            </a>{" "}
                          </li>
                        )
                      }
                      )
                    }
                </>
                : ''
            }
            </span>

          </>
          : 
          <TabListShimmer />
      }
    </>
  );
};

export default TabList;
